export const FETCHING_CLAN_INFO_REQUEST = 'clan/FETCHING_CLAN_INFO_REQUEST';
export const FETCHING_CLAN_INFO_FAILURE = 'clan/FETCHING_CLAN_INFO_FAILURE';
export const FETCHING_CLAN_INFO_SUCCESS = 'clan/FETCHING_CLAN_INFO_SUCCESS';
